import { type WorkingPane } from "./ActivePanes";
import BaseObject from "./BaseObject";

class TabItemData extends BaseObject {
  public get className(): string {
    return "TabItemData"; // no itx
  }

  get isPersistent(): boolean {
    return false;
  }

  constructor(paneId: string, title: string, obj?: WorkingPane, closeable?: boolean, screen2?: boolean, color?: undefined | string | ((tabItemData: TabItemData) => string | undefined)) {
    super();

    this.paneId = paneId;
    this.title = title;
    this.obj = obj;
    this.closeable = closeable || false;
    this.screen2 = screen2 || false;
    this.color = color;
  }

  public get title(): string {
    return this._name || "";
  }
  public set title(value: string) {
    this._name = value;
  }

  paneId: string = ""; // defined in BaseObject
  subPageId?: string;

  closeable: boolean = false;
  color?: undefined | string | ((tabItemData: TabItemData) => string | undefined); // color can be a string or a function that returns a string

  //
  // for Document-Tabs only
  //

  obj?: WorkingPane;

  _open: boolean = false;

  get open(): boolean {
    if (this.obj) {
      return (
        this.obj.activePanes.getActiveId() == this.paneId && this.obj.activePanes.getActiveSubPageId() == this.subPageId
      );
    } else {
      return this._open;
    }
  }

  set open(value: boolean) {
    this.setOpen(value, true);
  }

  setOpen(value: boolean, doRaiseOnChange: boolean): void {
    if (this.obj) {
      if (value) {
        this.obj.activePanes.setActiveId(this.paneId, this.subPageId);
        if (doRaiseOnChange) {
          this.obj.activePanes.getActiveItem().tabItemData?.raiseOnChange("active");
        }
      } else {
        this.obj.activePanes.setActiveId("", undefined);
      }
      if (doRaiseOnChange) {
        this.raiseOnChange("open");
      }
    } else {
      const lastOpen = this._open;
      this._open = value;
      if (doRaiseOnChange && lastOpen != value) {
        this.raiseOnChange("open");
      }
    }
  }

  get active(): boolean {
    const screen2Active = state.activeDocumentScreen == 2;
    return this.open && this.screen2 == screen2Active;
  }

  set active(value: boolean) {
    this.open = value;
  }

  screen2?: boolean;
}

export default TabItemData;
